import { atom } from 'recoil';

export const isRoutesFilterModalOpenAtom = atom<boolean>({
  key: 'isRoutesFilterModalOpenState',
  default: false,
});
